luckyBetToggleButton = {};

// InputHelpers.addGenerics(button);
// button.registerButton = function (controller) {
//   this.button = resourceManager.get(button.Props.FQN + ":button");

luckyBetToggleButton.create = function () {
  var button = new PIXI.Container();

  button.luckyBetMessage = undefined;
  button._isPromotion = false;

  InputHelpers.addGenerics(button);

  button.origEnableButton = button.enableButton;
  button.origDisableButton = button.disableButton;
  button.enableButton = () => {
    if (button.canEnable() === true && button.button.isButtonEnabled === false) {
      // button is becoming enabled
      // show button anims container
      button.showButtonAnimContainer();
    }
    button.origEnableButton();
  };
  button.disableButton = () => {
    if (button.button.isButtonEnabled === true) {
      // button is becoming disabled
      // hide button anims container
      button.hideButtonAnimContainer();
    }
    button.origDisableButton();
  };

  button._flags.showLuckyBetActive = false;
  button.canPlaceBet = false;

  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button._flags.platformEnabled = false;
  button._flags.platformVisible = false;

  button.activeMovieInfo = {};
  button.idleMovieInfo = {};
  button.scaleInInfo = {};
  button.scaleOutInfo = {};

  // button.pauseIdleAnimTimeline = function () {
  //   button.idleAnimTimeline.pause();
  // };

  // button.restartIdleAnimTimeline = function () {
  //   if (!button.idleAnimTimeline) {
  //     button.createIdleAnimTimeline();
  //   }
  //   button.idleAnimTimeline.time(0, true).restart(true);
  // };

  // button.createIdleAnimTimeline = function () {
  //   button.idleAnimTimeline = gsap.timeline({ repeat: -1, paused: true }).call(
  //     () => {
  //       if (button.canEnable() && button._flags.showLuckyBetActive !== true && button.button.isButtonEnabled) {
  //         button.playIdleAnim();
  //       } else {
  //         button.pauseIdleAnimTimeline();
  //       }
  //     },
  //     undefined,
  //     '<+=3.5'
  //   );
  // };

  button.onButtonIdleTimerExpired = function () {
    if (button.canEnable() && button._flags.showLuckyBetActive !== true && button.button.isButtonEnabled) {
      if (button.skipFirstIdleAnim === true) {
        button.skipFirstIdleAnim = false;
      } else {
        button.playIdleAnim();
      }
    }
  };

  button.canShow = function () {
    return !freespins.inFreespins && this._flags.platformVisible;
  };

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;
    const goldenbetStakes = this.gameConfig.data.slotConfig.gameModes.GOLDENBET_BUY.coinSizes;
    const baseStake = resourceManager.getController('stakeController').BaseStake;
    const adjustedBaseStake = baseStake / 10;

    const isCurrentBetAllowed = goldenbetStakes.includes(adjustedBaseStake);
    button.canPlaceBet = isCurrentBetAllowed;

    var allow =
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !this._isPromotion &&
      this._flags.platformEnabled &&
      goldenbetStakes.length !== 0 &&
      isCurrentBetAllowed;

    this.button.buttonDisabled.alpha = allow ? 1 : 0.5;

    return allow;
  };

  button.getCanPlaceBet = function () {
    return button.canPlaceBet;
  };

  button.onConfig = function (config) {
    this._flags.platformEnabled = config.data.uiElements.btnUpstake.enabled;
    this._flags.platformVisible = config.data.uiElements.btnUpstake.visible;

    this.gameConfig = config;
  };

  button.abortLuckyBetMessage = async function () {
    if (button.luckyBetMessage !== undefined && button.luckyBetMessage.visible === true) {
      if (button.removeLuckyBetMessageTimer !== undefined) {
        timerManager.stop(button.removeLuckyBetMessageTimer);
      }

      if (button.scaleInInfo.tween && button.scaleInInfo.tween.isActive()) {
        // in the process of being shown
        button.scaleInInfo.tween.progress(1);
        await button.scaleInInfo.promise;

        // we can remove
        button.hideLuckyBetMessage();
      } else if (button.scaleOutInfo.tween && button.scaleOutInfo.tween.isActive()) {
        // in the process of being hidden
        // no need to do anything
      } else {
        // its just there
        // we we can remove
        button.hideLuckyBetMessage();
      }
    }
  };

  button.onGameControllerStartGame = async function () {
    await button.abortLuckyBetMessage();
  };

  button.isAllowed = function () {
    return this._flags.platformEnabled;
  };

  button.setupResources = function () {
    let self = this;
    messageBus.subscribe('spinner:GameConfigEvent', function () {
      self.onLayoutComplete();
    });

    messageBus.subscribe('buttonIdleTimerExpired', button.onButtonIdleTimerExpired.bind(button));
    messageBus.subscribe('spinner:GameConfigEvent', button.onConfig.bind(button));
    messageBus.subscribe('gameController:startGame', button.onGameControllerStartGame.bind(button));
    messageBus.subscribe('common:PromotionStarted', button.promotionStarted.bind(button));
    messageBus.subscribe('common:PromotionEnded', button.promotionEnded.bind(button));
    messageBus.subscribe('stake:stakeChanged', button.onStakeChanged.bind(button));
  };

  button.onLayoutComplete = function () {
    button.luckyBetMessage = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage');
    button.luckyBetMessagePanel = resourceManager.get(
      'buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage:luckyBetMessagePanel'
    );
    button.luckyBetMessageBetText = resourceManager.get(
      'buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage:luckyBetMessagePanel:luckyBetText2'
    );
    button.animParent = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton');

    button.idleAnim = resourceManager.get(
      'buttonContainer:buttonBar:luckyBetToggleButton:buttonAnimsContainer:buttonIdle'
    );
    button.onAnim = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton:buttonAnimsContainer:buttonOn');
    button.activeAnim = resourceManager.get(
      'buttonContainer:buttonBar:luckyBetToggleButton:buttonAnimsContainer:buttonActive'
    );
    button.buttonAnimsContainer = resourceManager.get(
      'buttonContainer:buttonBar:luckyBetToggleButton:buttonAnimsContainer'
    );

    button.idleAnim.gotoAndStop(0);
    button.idleAnim.visible = false;
    button.onAnim.gotoAndStop(0);
    button.onAnim.visible = false;
    button.activeAnim.gotoAndStop(0);
    button.activeAnim.visible = false;
    button.buttonAnimsContainer.visible = false;

    if (button.luckyBetMessage !== undefined) {
      button.luckyBetMessage.visible = false;
    }

    button.removeLuckyBetMessageTimer = undefined;
  };

  button.showButton = function () {
    if (this.canShow()) {
      if (!button._flags.showLuckyBetActive) {
        this.button.buttonDisabled.visible = true;
        this.button.buttonEnabled.visible = false;
      } else {
        this.button.buttonDisabled.visible = false;
        this.button.buttonEnabled.visible = true;
      }

      this.button.visible = true;
    } else {
      this.button.visible = false;

      this.button.buttonDisabled.visible = false;
      this.button.buttonEnabled.visible = false;
    }
  };

  button.enterBuyABonus = function () {
    // on entering buy a bonus we must disable lucky bet
    button._flags.showLuckyBetActive = false;
    button.cancelLuckyBet();
  };

  button.cancelLuckyBet = async function () {
    button.abortLuckyBetMessage();

    // button.luckyBetAnim.gotoAndStop(0);
    this.button.alpha = 1;
    button.stopOnAnim(true);

    gameData.encoreEnabled = false;

    button.handleStakeChange(true);
  };

  button.handleStakeChange = function (broadcast) {
    const stakeController = resourceManager.getController('stakeController');
    const bpl = stakeController.BaseStake / 25;
    const luckyBetEnabled = gameData.encoreEnabled;
    const stakeMultiplier = luckyBetEnabled ? 1.25 : 1;
    stakeController.setStakeMultiplier(stakeMultiplier);
    game.changeStake(stakeController.BaseStake * stakeMultiplier, bpl);

    if (broadcast) {
      stakeController.broadcastCurrentStake();
    }
  };

  button.setRecovery = function () {
    // only called when we are recovering the game to set the game as lucky bet active
    button._flags.showLuckyBetActive = true;
    gameData.encoreEnabled = true;
    button.handleStakeChange(true);
  };

  button.promotionStarted = function () {
    this._isPromotion = true;
  };

  button.promotionEnded = function () {
    this._isPromotion = false;
  };

  button.playIdleAnim = async function () {
    this.button.alpha = 0;
    await button.playAnimAsync(button.idleAnim, button.idleMovieInfo);
    this.button.alpha = 1;
  };

  button.stopIdleAnim = async function () {
    if (button.idleAnim.playing === true) {
      button.idleAnim.gotoAndStop(0);
      button.idleAnim.visible = false;

      if (button.idleMovieInfo) {
        button.idleMovieInfo.resolver(); // exit any awaits
        await button.idleMovieInfo.promise;
      }
    }

    // button.pauseIdleAnimTimeline();
  };

  button.showButtonAnimContainer = function () {
    if (button.buttonAnimsContainer) {
      button.buttonAnimsContainer.visible = true;
      if (button._flags.showLuckyBetActive !== true) {
        // button.skipFirstIdleAnim = true;
        // button.restartIdleAnimTimeline();
      }
    }
    if (button._flags.showLuckyBetActive === true) {
      // this.button.alpha = 0;
    }
  };

  button.hideButtonAnimContainer = function () {
    if (button.buttonAnimsContainer) {
      button.buttonAnimsContainer.visible = false;
    }
    // button.pauseIdleAnimTimeline();
    button.stopIdleAnim();
    if (button._flags.showLuckyBetActive === true) {
      this.button.alpha = 1;
    }
  };

  button.playAnimAsync = async function (anim, movieInfo) {
    let resolver = null;
    const promise = new Promise((resolve) => {
      resolver = resolve;
    });

    anim.visible = true;
    anim.onComplete = () => {
      resolver();
    };
    anim.gotoAndPlay(0);

    if (movieInfo) {
      movieInfo.anim = anim;
      movieInfo.promise = promise;
      movieInfo.resolver = resolver;
      movieInfo.stoppedPrem = false;
    }

    await promise;

    anim.visible = false;
  };

  button.playActiveAnim = async function () {
    await button.stopIdleAnim();
    await button.playAnimAsync(button.activeAnim, button.activeMovieInfo);

    if (button.activeMovieInfo.stoppedPrem !== true) {
      // happy to continue playing the on anim
      button.onAnim.visible = true;
      button.onAnim.gotoAndPlay(0);
    }
  };

  button.stopActiveAnim = function () {
    if (button.activeAnim.playing === true) {
      button.activeAnim.gotoAndStop(0);
      button.activeAnim.visible = false;

      if (button.activeMovieInfo) {
        button.activeMovieInfo.stoppedPrem = true;
        button.activeMovieInfo.resolver(); // exit any awaits
      }

      // button.skipFirstIdleAnim = true;
      // button.restartIdleAnimTimeline();
    }
  };

  button.stopOnAnim = function (fromCancel = false) {
    button.stopActiveAnim();
    button.onAnim.gotoAndStop(0);
    button.onAnim.visible = false;

    // we might be stopping because we are spinning, not being cancelled
    if (fromCancel === true) {
      // button.skipFirstIdleAnim = true;
      // button.restartIdleAnimTimeline();
    }
  };

  button.setStakeOnPanel = function () {
    const stakeController = resourceManager.getController('stakeController');
    const stakeMultiplier = 1.25;
    const stake = stakeController.BaseStake * stakeMultiplier;
    button.luckyBetMessageBetText.setTranslationParameters(gdk.formatCurrency(stake));
  };

  button.onStakeChanged = function (stake) {
    if (button._flags.showLuckyBetActive) {
      // golden bet is active
      button.setStakeOnPanel();
    }
  };

  button.showLuckyBetMessage = async function () {
    if (button.luckyBetMessage !== undefined) {
      button.luckyBetMessage.visible = true;

      // get stake from where?
      button.setStakeOnPanel();

      await game.tweenFromToAsync(
        button.luckyBetMessagePanel.scale,
        {
          x: 0,
          y: 0,
        },
        {
          x: 1,
          y: 1,
          duration: 0.5,
          ease: 'bounce.out',
        },
        button.scaleInInfo
      );
    }
  };

  button.hideLuckyBetMessage = async function () {
    if (button.luckyBetMessage !== undefined) {
      await game.tweenFromToAsync(
        button.luckyBetMessagePanel.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 0,
          y: 0,
          duration: 0.15,
          ease: 'none',
        },
        button.scaleOutInfo
      );

      button.luckyBetMessage.visible = false;
    }
  };

  button.onPressedCallback = function () {
    button._flags.showLuckyBetActive = !button._flags.showLuckyBetActive;
    game.resetWinnings();

    if (button._flags.showLuckyBetActive) {
      if (button.luckyBetMessage !== undefined) {
        button.showLuckyBetMessage();
        button.removeLuckyBetMessageTimer = timerManager.addTimer(4000, undefined, function () {
          button.hideLuckyBetMessage();
        });
      }

      button.playActiveAnim();
      soundManager.play('activateGoldenBet');

      gameData.encoreEnabled = true;
      button.handleStakeChange(true);
    } else {
      button.cancelLuckyBet();
      if (button.luckyBetMessage !== undefined) {
        soundManager.play('cancelGoldenBet');
      }
    }
  };

  return button;
};

luckyBetToggleButton.initialise = function (json, object) {
  object.setupResources();
};

luckyBetToggleButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'luckyBetToggleButton',
  luckyBetToggleButton.create,
  luckyBetToggleButton.initialise,
  luckyBetToggleButton.getFilesRequired
);
